import { Moment } from 'moment'

export interface DateRangeFilters {
  startDate: Moment
  endDate: Moment
  startHour?: Moment
  endHour?: Moment
  [key: string]: unknown
}

type AdjustedFilters = Omit<DateRangeFilters, 'startDate' | 'endDate' | 'startHour' | 'endHour'> & {
  inicio: string
  fim: string
}

const adjustDate = (aMomentObject: Moment): string => aMomentObject.format('YYYY-MM-DD')

const adjustTime = (aMomentObject: Moment): string => aMomentObject.format('HH:mm:ss')

const adjustDateRange = (filters: DateRangeFilters): AdjustedFilters => {
  const { endDate, endHour, startDate, startHour, ...props } = filters

  const fim = `${adjustDate(endDate)} ${endHour ? adjustTime(endHour) : '23:59:59'}`
  const inicio = `${adjustDate(startDate)} ${startHour ? adjustTime(startHour) : '00:00:00'}`

  return { ...props, fim, inicio }
}

export default adjustDateRange
